export default function StatsSection() {
  const stats = [
    { value: '50,000+', label: '视频资源', icon: 'ri-video-line' },
    { value: '3,000万+', label: '月活跃用户', icon: 'ri-user-line' },
    { value: '99.9%', label: '播放流畅率', icon: 'ri-wifi-line' },
    { value: '4K', label: '超清画质', icon: 'ri-4k-line' },
  ];

  return (
    <section className="py-10 md:py-12">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${stat.icon} text-xl text-primary-600`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}